import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpInputComponent } from './containers/otp-input/otp-input.component';

@NgModule({
  declarations: [OtpInputComponent],
  exports: [OtpInputComponent],
  imports: [CommonModule, NgOtpInputModule],
})
export class OtpInputModule {}
